import { render, staticRenderFns } from "./NewW2Channel.vue?vue&type=template&id=656f3043&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./NewW2Channel.vue?vue&type=script&lang=js"
export * from "./NewW2Channel.vue?vue&type=script&lang=js"
import style0 from "./NewW2Channel.vue?vue&type=style&index=0&id=656f3043&prod&lang=scss&scoped=true"
import style1 from "./NewW2Channel.vue?vue&type=style&index=1&id=656f3043&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f3043",
  null
  
)

export default component.exports